// extracted by mini-css-extract-plugin
export var section = "reasons-module--section--dPVav";
export var inner = "reasons-module--inner--2Pe9X";
export var inner_hero = "reasons-module--inner_hero--2NnCf";
export var inner_tiles = "reasons-module--inner_tiles--bqq6v";